import React from 'react';
import { StyleSheet } from 'react-native';
import Colors from '../../../../constants/Colors';
import SpaceUtilizationWidget from './SpaceUtilizationWidget';
import ProgressBarTile from '../../ProgressBarWidget/ProgressBarTile';

interface LiveModeHeaderProps {
  count: number | null,
  target: number | null,
}

const LiveModeHeader = ({ count, target }: LiveModeHeaderProps) => <SpaceUtilizationWidget
  tooltipText='Shows the number of occupants, capacity, and occupancy percentage'
  row
  content={<ProgressBarTile
    {...{ count, target }}
    value={Math.floor(100 * (count / target))}
    style={styles.progressBar}
    alternate
    showCount
    showPercentage={false}
    color={Colors.light.hereworksBlue500}
  />}
/>;

const styles = StyleSheet.create({
  progressBar: {
    width: '100%',
    maxWidth: 400,
    alignSelf: 'flex-end',
    minHeight: 54,
    marginHorizontal: 0,
    padding: 0,
  },
});

export default LiveModeHeader;
